import { createAsyncThunk } from '@reduxjs/toolkit'
import { cashOutBetHiLoService, myBetsHiLoService, getUnfinishedBetService, openCardHiLoService, placeBetHiLoService } from '../services/hiloGame.service'
import { BET_RESULT } from 'constants/index'
import { setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { openErrorToaster, openSuccessToaster } from 'helpers/toaster.helpers'
import { resetCalculatedProfits, setCalculatedProfits } from './hiLoGame.slice'
import i18n from 'i18next'

export const placeBetHiLo = createAsyncThunk('hi-lo-game/place-bet', async ({ payload, buttonClickAudio }, thunkApi) => {
  try {
    const res = await placeBetHiLoService(payload)
    const { onSuccess } = payload
    const { gameSound } = thunkApi?.getState()?.gameSetting
    gameSound && buttonClickAudio?.play()
    openSuccessToaster({ message: i18n.t('BET_PLACED_SUCCESS') })
    onSuccess(res)
    return res
  } catch (error) {
    const errorMessage = error?.[0]?.description
    if (errorMessage != 'Insufficient funds') {
      openErrorToaster({ message: i18n.t('PLACE_BET_FAILED') })
    }
    return thunkApi.rejectWithValue(errorMessage)
  }
})

export const openCardHiLo = createAsyncThunk('hi-lo-game/open-card', async ({ data, setBetAmount, minBetData, betAmount, handleChangeMainCard }, thunkApi) => {
  try {
    const res = await openCardHiLoService(data)
    const card = document.querySelector('.card-center')

    card.classList.toggle('flipped')
    const openedCard = res.betStates[res.betStates.length - 1].openedCard
    if (res?.result === BET_RESULT.LOST) {
      openErrorToaster({ message: i18n.t('LOST') })
      thunkApi.dispatch(setServerSeedHash(res?.serverSeed))
      thunkApi.dispatch(resetCalculatedProfits({
        currentCardIndex: openedCard
      }))
    } else {
      thunkApi.dispatch(setCalculatedProfits({
        currentCardIndex: openedCard,
        coefficient: res.betStates[res.betStates.length - 1].coefficient,
        betAmount
      }))
    }
    handleChangeMainCard(openedCard)
    return res
  } catch (error) {
    console.log('CATCH ERROR', error)
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyBetsHiLo = createAsyncThunk('hi-lo-game/my-bets', async (data, thunkApi) => {
  try {
    const res = await myBetsHiLoService(data)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const cashOutHiLo = createAsyncThunk('hi-lo-game/cash-out-bet', async ({ payload }, thunkApi) => {
  try {
    const { data, cashoutAudio, onSuccess } = payload
    const res = await cashOutBetHiLoService(data)
    thunkApi.dispatch(setServerSeedHash(res?.serverSeed))
    const { gameSound } = thunkApi?.getState()?.gameSetting
    gameSound && cashoutAudio?.play()
    onSuccess(res)
    return res
  } catch (error) {
    openErrorToaster({ message: i18n.t('CASH_OUT_FAILED') })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getUnfinishedBet = createAsyncThunk('hi-lo-game/get-unfinished-bet', async (_, thunkApi) => {
  try {
    const res = await getUnfinishedBetService()
    if (res?.hasUnfinishedBet) {
      let coefficient = 1
      let currentCardIndex
      openSuccessToaster({ message: i18n.t('YOU_ALREADY_HAVE_A_BET_PLACED') })
      const betStates = res.unfinishedBet.betStates
      const betAmount = res.unfinishedBet.betAmount
      if (betStates.length) {
        coefficient = betStates[betStates.length - 1].coefficient
        currentCardIndex = betStates[betStates.length - 1].openedCard
      } else {
        currentCardIndex = res.unfinishedBet.initialCard
      }
      thunkApi.dispatch(setCalculatedProfits({
        currentCardIndex,
        betAmount,
        coefficient
      }))
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
